import React from "react";
import classNames from "classnames";
import withStyles from "react-jss";

const styles = (theme) => {
	return {
		root: {
			width: "auto",
			marginLeft: "0",
			display: "flex",
			alignItems: "center",
		},
		caption: {
			fontFamily: theme.fonts.bold,
			fontSize: "16px",
			lineHeight: 1,
			letterSpacing: "2.3px",
			color: theme.palette.colors.darkSlateBlue,
			textTransform: "uppercase",
			marginRight: "auto",
		},
		wrapper: {
			fontSize: 0,
			lineHeight: 0,
		},
		item: {
			width: "50px",
			height: "50px",
			borderRadius: "10px",
			display: "inline-flex",
			justifyContent: "center",
			alignItems: "center",
			marginRight: "10px",
			cursor: "pointer",
			"& span": {
				color: theme.palette.colors.purplishBlue,
				fontSize: "20px",
			},
			"&:last-child": {
				marginRight: 0,
			},
		},
		activeItem: {
			border: `solid 1px ${theme.palette.colors.lightGrayishViolet}`,
		},
		isStub: {
			"& $item": {
				backgroundColor: theme.palette.colors.disabled,
				"& span": {
					display: "none",
				},
			},
		},
		[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
			root: {
				width: "auto",
			},
		},
		[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
			root: {
				width: "auto",
			},
			caption: {
				fontSize: "14px",
				lineHeight: "1.14",
				letterSpacing: "2px",
				marginLeft: "25px",
			},
		},
		[`@media (max-width: ${theme.media.sm})`]: {
			root: {
				display: "none",
			},
		},
	};
};

class OrientationChanger extends React.PureComponent {
	static defaultProps = {
		onChange: () => {},
		flat: false,
		datatest: null,
	};

	constructor(props) {
		super(props);

		this.state = {
			portrait: props.flat,
		};
	}

	changeHandler(type) {
		this.props.onChange(type);
		this.setState({
			portrait: type,
		});
	}

	render() {
		let classes = this.props.classes;
		return (
			<div
				className={classNames(classes.root, {
					[classes.isStub]: this.props.stub,
				})}
			>
				{!!this.props.sortView && <div className={classes.caption}>{this.props.sortView}</div>}
				<div className={classes.wrapper}>
					<div
						style={{ transform: "rotate(90deg)" }}
						onClick={() => this.changeHandler(false)}
						datatest={this.props.datatest}
						className={classNames(classes.item, {
							[classes.activeItem]: !this.state.portrait,
						})}
					>
						<span className="icon24 icon-hamburger-menu-1" />
					</div>
					<div
						onClick={() => this.changeHandler(true)}
						datatest={this.props.datatest}
						className={classNames(classes.item, {
							[classes.activeItem]: this.state.portrait,
						})}
					>
						<span className="icon24 icon-hamburger-menu-1" />
					</div>
				</div>
			</div>
		);
	}
}

export default withStyles(styles)(OrientationChanger);
